import { Box, Image } from "@chakra-ui/react";
import speaker from "../../Announcement/images/speaker.png";
import { useNavigate } from "react-router-dom";

/**
 * @description 公告按钮
 * @returns {JSX.Element}
 */
const AnnouncementButton = () => {
  const navigate = useNavigate();
  const handleOnClick = () => navigate("?announcement_open=true");

  return (
    <Box
      alignItems="center"
      height={{ base: "30px", md: "40px", lg: "40px", xl: "55px" }}
      width={{
        base: "40px",
        md: "55px",
        lg: "55px",
        xl: "80px",
      }}
      onClick={handleOnClick}
      bgSize={"100% 100%"}
      backgroundImage={speaker}
    ></Box>
  );
};

export default AnnouncementButton;
